import { render, staticRenderFns } from "./ele-waiters.vue?vue&type=template&id=5700f8d1&scoped=true&"
import script from "./ele-waiters.vue?vue&type=script&lang=js&"
export * from "./ele-waiters.vue?vue&type=script&lang=js&"
import style0 from "./ele-waiters.vue?vue&type=style&index=0&id=5700f8d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5700f8d1",
  null
  
)

export default component.exports